<template>
  <div class="">
    <FilePond
      name="file"
      ref="pond"
      :label-idle="labelIdle"
      :allow-multiple="true"
      :allow-revert="false"
      :accepted-file-types="acceptedFileTypes"
      :oninitfile="onInitFile"
      :onprocessfile="onProcessFile"
      :onprocessfiles="onProcessFiles"
      :instant-upload="true"
      :server="serverOptions"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  name: 'CreateMedia',

  components: {
    FilePond,
  },

  props: {
    orderItemId: {
      type: String,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
      default: 'image/jpeg, image/png, application/pdf, video/mp4',
    },
    onMediaUploaded: {
      type: Function,
      default: null,
    },
    onActive: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      labelIdle:
        "Drop files here or <span class='underline cursor-pointer'>Browse</span> to upload",
      active: false,
      serverOptions: {
        process: {
          url: `/api/v1/order-items/${this.orderItemId}/media`,
          method: 'POST',
          withCredentials: true,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          timeout: 300000,
          onload: (response) => {
            const { data = null } = JSON.parse(response);
            this.onMediaUpload(data);
          },
          onerror: null,
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  methods: {
    setActive(active) {
      this.active = active;
      if (typeof this.onActive === 'function') {
        this.onActive(active);
      }
    },
    onInitFile() {
      this.setActive(true);
    },
    onProcessFile(error, file) {
      setTimeout(() => {
        if (typeof this.$refs.pond === 'undefined') {
          return;
        }

        if (file.status === 5) {
          this.$refs.pond.removeFile(file.id);
        }

        if (this.$refs.pond.getFiles().length === 0) {
          this.setActive(false);
        }
      }, 1500);
    },
    onProcessFiles() {
      this.setActive(false);
      this.$emit('completed');
    },
    async onMediaUpload(data) {
      if (!data) {
        return;
      }

      try {
        const orderItemId = await this.$store.dispatch('entities/persistEntities', {
          type: 'orderItems',
          data,
        });

        if (typeof this.onMediaUploaded === 'function') {
          this.onMediaUploaded(orderItemId, data);
        }
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style>
.filepond--root {
  @apply mb-0;
}
</style>
